import { Clock } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useSeo } from "@/lib/seo";
import { PageHero } from "@/components/PageHero";
import { QuoteForm } from "@/components/forms/QuoteForm";
import { Reveal } from "@/components/Motion";

export default function Quote() {
  const { t } = useLang();
  const q = t.quote;
  useSeo("quote");
  return (
    <>
      <PageHero eyebrow={q.eyebrow} title={q.title} intro={q.reply} img="/img/warehouse2.jpg" testId="quote-hero" />
      <section className="bg-white py-20 lg:py-28" data-testid="quote-page">
        <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:px-12">
          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <div className="flex items-center gap-3 bg-[#0F2138] p-6 text-white">
                <Clock className="h-6 w-6 text-[#C59B27]" aria-hidden="true" />
                <p className="font-serif text-lg" data-testid="quote-24h">{q.reply}</p>
              </div>
              <ul className="border border-t-0 border-[#8EA3BC]/40">
                {q.side.map((s) => <li key={s} className="border-b border-[#8EA3BC]/30 p-5 text-[#334155] last:border-b-0">{s}</li>)}
              </ul>
            </div>
          </aside>
          <Reveal className="lg:col-span-8"><QuoteForm /></Reveal>
        </div>
      </section>
    </>
  );
}
